module.exports = __webpack_public_path__ + "static/media/Event-07.be866c64.svg";